import React from "react";
import { Link } from "react-router-dom";
import SectionTitleSpecial from "../../components/SectionTitle/SectionTitleSpecial";
import RightArrow from "../../components/SVG";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import shapeImg2 from "../../assets/img/about/ed-shape-3-1.png";
import sap1 from "../../assets/img/sap/sapmembership01.jpg";
import sap2 from "../../assets/img/sap/sapmembership02.jpg";
import members from "../../assets/img/mem_logo.png";

const About = () => {
  const items = [
    {
      description: [
        "Access to SAP's events at no or low cost",
        "Opportunities for professional development through participation in SAP's activities",
        "Networking with top and emerging leaders in the aquaculture industry, academia and research world",
        "Reach the strategic partners of SAP such as the Global Aquaculture Alliance, World Aquaculture Society and the Institution of Aquaculture and gain from their exclusive offers for SAP members",
      ],
    },
    {
      description: [
        "A defined number of seats reserved in SAP events",
        "Same opportunities for professional development and networking. Additionally, mentorship and career opportunities.",
      ],
    },
  ];

  return (
    <div
      id="it-about"
      className="it-about-3-area it-about-4-style p-relative pt-0 pt-md-5 pt-50"
      style={{ paddingBottom: "80px" }}
    >
      <div className="container">
        {/* Row with top-aligned left text */}
        <div className="row items-start">
          {/* Left column */}
          <div className="col-xl-6 col-lg-6 flex flex-col justify-start">
            <SectionTitleSpecial
              itemClass="it-about-title-box mb-0 section-title-fixed-width"
              subTitle="Become a SAP Member"
            />

            <div className="it-about-text mb-3">
              <div className="row">
                <p className="mb-2">
                  SAP offers two types of membership: Life Membership and
                  Student Membership. Details for both options are available on
                  the Membership page. If you are already a member, simply sign
                  in to access exclusive content and member-only resources. For
                  any assistance with your membership or sign-in, please contact
                  us at
                  <a
                    className="ml-2 text-blue-700 hover:text-blue-700"
                    href="mailto:contact@aquaprofessional.org"
                  >
                    mail to : contact@aquaprofessional.org
                  </a>
                  .
                </p>
              </div>
            </div>

            <Tabs className="it-course-details-wrap mb-0">
              <div className="it-course-details-content">
                <div className="tab-content" id="nav-tabContent">
                  <TabPanel>
                    <div className="flex max-w-[500px] gap-3 mb-2">
                      <Link className="ed-btn-theme mb-0" to="/login">
                        Member Login
                        <i>
                          <RightArrow />
                        </i>
                      </Link>

                      <Link className="ed-btn-theme mb-0" to="/signup">
                        Join now
                        <i>
                          <RightArrow />
                        </i>
                      </Link>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="col-xl-12">
                      <div className="it-about-4-list-wrap d-flex align-items-start">
                        <div className="it-about-5-list mb-2">
                          <ul style={{ backgroundColor: "transparent" }}>
                            {items[1].description.map((point, index) => (
                              <li className="pr-0 pb-2 text-black" key={index}>
                                <i className="fa-regular fa-angles-right"></i>
                                {point}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <Link className="ed-btn-theme mb-0" to="/student-login">
                        SignIn for Student Membership
                        <i>
                          <RightArrow />
                        </i>
                      </Link>
                    </div>
                  </TabPanel>
                </div>
              </div>
            </Tabs>
          </div>

          {/* Right column */}
          <div className="col-xl-6 col-lg-6 d-flex items-center justify-center">
            <div className="ed-about-3-thumb-wrap p-relative">
              <img
                src={members}
                alt="SAP Members"
                className="w-[500px] h-[300px] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
